var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenEllipse = function SvgGreenEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2,
    cy: 27.829,
    r: 26.971,
    fill: "#92DE63",
    transform: "rotate(180 27.2 27.83)"
  })));
};
export { SvgGreenEllipse as ReactComponent };
export default __webpack_public_path__ + "images/green-ellipse.svg";